import React from 'react';

import { BiSearchAlt2 } from "react-icons/bi";
import { BiHide } from "react-icons/bi";
import { FaExclamationTriangle } from "react-icons/fa";
import { IoIosRefresh } from "react-icons/io";
import { IoMdHelpCircleOutline } from "react-icons/io";
import { IoBuildOutline } from "react-icons/io5";
import { TiArrowForwardOutline } from "react-icons/ti";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { AiOutlineSound } from "react-icons/ai";
import { BsCameraReels } from "react-icons/bs";
import { MdChangeHistory } from "react-icons/md";
import { FiPlus } from "react-icons/fi";
import { RiAsterisk } from "react-icons/ri";
import { RiMoonLine } from "react-icons/ri";
import { RxChatBubble } from "react-icons/rx";
import { TbDetails } from "react-icons/tb";
import { TbListDetails } from "react-icons/tb";
import { HiOutlineClipboardCopy } from "react-icons/hi";
import { BiPaste } from "react-icons/bi";
import { BiBarcode } from "react-icons/bi";
import { BiWorld } from "react-icons/bi";

const renderSwitch = (param) => {
  switch(param) {
    case 'arrowRight':
      return < TiArrowForwardOutline />;
    case 'arrowRight2emGray':
      return < TiArrowForwardOutline style={{ fontSize: '2em', color: 'gray' }} />;
    case 'change':
      return < MdChangeHistory />;
    case 'circleInfo':
      return < AiOutlineInfoCircle />;
    case 'q4moon':
      return < RiMoonLine />;
    case 'circleHook':
      return < IoMdHelpCircleOutline />;
    case 'detailsHeading':
      return < TbDetails />;
    case 'details':
      return <TbListDetails />;
    case 'triangleBang':
      return < FaExclamationTriangle />;
    case 'hide':
      return < BiHide />;
    case 'refresh':
      return < IoIosRefresh />;
    case 'plus':
      return < FiPlus />;
    case 'wrench':
      return < IoBuildOutline />;
    case 'magnify':
      return < BiSearchAlt2 />;
    case 'asterisk':
      return < RiAsterisk />;
    case 'chat':
      return < RxChatBubble />;
    case 'copy':
      return <HiOutlineClipboardCopy />;
    case 'paste':
      return <BiPaste />;
    case 'barcode':
      return <BiBarcode />;
    case 'globe':
      return <BiWorld />;
    case 'audioPlayback':
      return < AiOutlineSound />;
    case 'videoPlayback':
      return < BsCameraReels />;
    // case 'videoPlayback1.5em':
    //   return < BsCameraReels size={'1.5em'} />;
    default:
      return param;
  }
}

export const GetIcon = ( {toGet} ) => {
  return renderSwitch(toGet);
}

export default GetIcon